import { H2, P } from '@mote/ui/components'
import styled, { th } from '@xstyled/styled-components'
import { CTABlock, Container } from './shared'

export const CallToActionSection = (): JSX.Element => {
  return (
    <Root>
      <CTAContainer>
        <CTAContentContainer>
          <CTAContent>
            <CTATitle>Get started free!</CTATitle>
            <CTADescription>
              Improve listening skills, build spoken word confidence across
              languages and nurture an incluse environment
            </CTADescription>
            <CTABlock />
          </CTAContent>
        </CTAContentContainer>
        <CTAImage />
      </CTAContainer>
    </Root>
  )
}

const Root = styled(Container)`
  gap: 0;
  padding-top: 40px;
  padding-bottom: 0;

  @media (max-width: 991px) {
    padding-top: 20px;
  }
`

const CTATitle = styled(H2).attrs({
  alignment: 'left',
  lineHeight: '123.5%',
  fontWeight: 400,
  color: 'black'
})`
  width: 80%;
  font-size: 39px;

  @media (max-width: 991px) {
    font-size: 32px;
  }
`

const CTAContainer = styled.div`
  display: flex;
  width: 90%;
  max-width: 1400px;
  flex-direction: row;
  align-items: center;
  border-radius: 24px 24px 0 0;
  background-color: ${th.color('grey.l4')};

  @media (max-width: 991px) {
    flex-direction: column;
    order: 0;
  }

  @media (max-width: 479px) {
    border-radius: 0;
  }
`

const CTAContentContainer = styled.div`
  display: flex;
  width: 50%;
  height: 100%;
  padding-top: 40px;
  padding-bottom: 20px;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;

  @media (max-width: 991px) {
    width: 100%;
    padding-top: 60px;
    padding-bottom: 60px;
    order: 1;
    flex: 0 auto;
  }

  @media (max-width: 479px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

const CTAContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 70%;

  @media (max-width: 991px) {
    width: 90%;
  }
`

const CTADescription = styled(P).attrs({
  fontSize: 18,
  color: 'grey.d2',
  lineHeight: '150%'
})`
  margin-bottom: 0;
  padding-top: 16px;
  padding-bottom: 16px;
  max-width: 400px;

  @media (max-width: 991px) {
    max-width: 600px;
  }
`

const CTAImage = styled.div`
  display: block;
  width: 50%;
  height: 80vh;
  padding-top: 40px;
  padding-bottom: 20px;
  align-items: flex-start;
  flex: 1;
  border-top-right-radius: 24px;
  background-image: url('https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/6319f35d9a7d9e84519bd585_Footer%20image%20(1).jpg');
  background-position: 20% 50%;
  background-size: cover;
  background-repeat: no-repeat;

  @media (max-width: 991px) {
    width: 100%;
    height: 40vh;
    flex: 0 auto;
  }

  @media (max-width: 767px) {
    height: 50vh;
  }

  @media (max-width: 479px) {
    height: 40vh;
    max-height: 300px;
    border-radius: 0;
  }
`
